// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import {
  UmsatzAuswertungRequest,
  type UmsatzstundenAuswertung,
} from "../../api";
import { useGetApi } from "../client";
import { useCallback } from "react";

export function useGetUmsatzStundenAuswertungByDate(): (
  baustellenId: string,
  buchungstyp: string,
  requestBody: UmsatzAuswertungRequest
) => Promise<UmsatzstundenAuswertung> {
  const getAPI = useGetApi();
  return useCallback(
    async (baustellenId, buchungstyp, requestBody) =>
      (await getAPI()).umsatz.getUmsatzStundenAuswertungByDate({
        baustellenId,
        buchungstyp,
        requestBody,
      }),
    [getAPI]
  );
}
